import { createActions, createReducer } from 'reduxsauce';
import GerarCtejs from 'Dados/GerarCtejs.js';
import DistribuiCte from 'Dados/DistribuiCte.js';

export const { Types, Creators } = createActions({
	buscarCidadeCte: [ 'payload' ],
	buscarCidadeCteSucesso: [ 'payload' ],
	buscarCte: [ 'payload' ],
	buscarCteSucesso: [ 'payload' ],
	buscarTransportadorasCte: [ 'payload' ],
	buscarTransportadorasCteSucesso: [ 'payload' ],
	buscarDistribuidorasCte: [ 'payload' ],
	buscarDistribuidorasCteSucesso: [ 'payload' ],
	buscarNotasCte: [ 'payload' ],
	buscarNotasCteSucesso: [ 'payload' ],
	buscarEstadosCte: [ 'payload' ],
	buscarEstadosCteSucesso: [ 'payload' ],
	visualizarSucesso: [ 'payload' ],
	setEmpresaSelecionada: [ 'payload' ],
	setTipoServico: [ 'payload' ],
	// -------------------------
	setMostrar: [ 'payload' ],
	notasEditCte: [ 'payload' ],
	buscarNotas: [ 'payload' ],
	buscarNotasSucesso: [ 'payload' ],
	editarCte: [ 'payload' ],
	editarCteSucesso: [ 'payload' ],
	incluirNotCte: [ 'payload' ],
	incluirNotCteSucesso: [ 'payload' ],
	validarCteUnico: [ 'payload' ],
	listaGerarCte: [ 'payload' ],
	listaGerarCteSucesso: [ 'payload' ],
	distribuidoraCte: [ 'payload' ],
	setNotasVisCte: [ 'payload' ],
	gerarTodosCte: [ 'payload' ],
	pesquisarCte: [ 'payload' ],
	pesquisarCteSucesso: [ 'payload' ],
	buscarDistTransp: [ 'payload' ],
	buscarDistTranspSucesso: [ 'payload' ],
	setLoad: [ 'payload' ],
	formularioDdsCte: [ 'payload' ],
});

const INIT_STATE = {
	estados: [],
	notasCte: [],
	transportadoras: [],
	cteBusca: [],
	empresasSelecionadas: [],
	distribuidorasCte: [],
	cidade: '',
	estadosAtual: '',
	alertMessage: '',
	showMessage: false,
	visualizar: false,
	tipoServico: [],
	setServico: '',
	// ------------------
	mostrar: false,
	dadosEditCte: [],
	notasEdtitCte: [],
	notasEdita: [],
	carregarCteGerar: [],
	distriCte: [],
	notasVisCte: [],
	ListPesquCte: [],
	ListaRem: [],
	load: false,
	formularioDados: []
};


const formularioDdsCte = (state = INIT_STATE, action) => ({
	...state,
	formularioDados: action.payload
});


const setLoad = (state = INIT_STATE, action) => ({
	...state,
	load: action.payload
});

const buscarDistTranspSucesso = (state = INIT_STATE, action) => ({
	...state,
	ListaRem: action.payload
});

const setMostrar = (state = INIT_STATE, action) => ({
	...state,
	mostrar: action.payload
});

const editarCteSucesso = (state = INIT_STATE, action) => ({
	...state,
	dadosEditCte: action.payload,
	notasEdtitCte: action.payload.notas
});

const notasEditCte = (state = INIT_STATE, action) => {
	let notasEdtitCte = state.notasEdtitCte.slice();
	notasEdtitCte.unshift(action.payload);

	return {
		...state,
		notasEdtitCte
	};
};

const incluirNotCteSucesso = (state = INIT_STATE, action) => {
	let notasEdtitCte = state.notasEdtitCte.slice();
	notasEdtitCte.unshift(action.payload);
	return {
		...state,
		notasEdtitCte
	};
};

const buscarNotasSucesso = (state = INIT_STATE, action) => {
	let notasEdita = state.notasEdita.slice();
	notasEdita.unshift(action.payload);

	return {
		...state,
		notasEdita
	};
};

const validarCteUnico = (state = INIT_STATE, action) => {
	const { carregarCteGerar } = state;

	const dados = action.payload;
	let index = dados.index;

	const novaLista = carregarCteGerar.filter((nota, i) => i != index);

	return {
		...state,
		carregarCteGerar: novaLista
	};
};

const listaGerarCte = (state = INIT_STATE, action) => ({
	...state,
	carregarCteGerar: []
});

const listaGerarCteSucesso = (state = INIT_STATE, action) => {

	return {
		...state,
		carregarCteGerar: action.payload,
		load: false
	};
};

const distribuidoraCte = (state = INIT_STATE, action) => ({
	...state,
	distriCte: DistribuiCte
});

const setNotasVisCte = (state = INIT_STATE, action) => ({
	...state,
	notasVisCte: action.payload
});

const gerarTodosCte = (state = INIT_STATE, action) => ({
	...state,
	carregarCteGerar: []
});

const pesquisarCteSucesso = (state = INIT_STATE, action) => ({
	...state,
	ListPesquCte: action.payload
});

// ------------------------------------------

const buscarEstadosCteSucesso = (state = INIT_STATE, action) => ({
	...state,
	estados: action.payload
});

const buscarCidadeCteSucesso = (state = INIT_STATE, action) => ({
	...state,
	cidade: action.payload
});

const buscarNotasCteSucesso = (state = INIT_STATE, action) => ({
	...state,
	notasCte: action.payload
});

const buscarTransportadorasCteSucesso = (state = INIT_STATE, action) => ({
	...state,
	transportadoras: action.payload
});

const buscarDistribuidorasCteSucesso = (state = INIT_STATE, action) => ({
	...state,
	distribuidorasCte: action.payload
});

const setEmpresaSelecionada = (state = INIT_STATE, action) => ({
	...state,
	empresasSelecionadas: action.payload
});

const buscarCteSucesso = (state = INIT_STATE, action) => ({
	...state,
	cteBusca: action.payload
});

const visualizarSucesso = (state = INIT_STATE, action) => ({
	...state,
	visualizar: true
});

const setTipoServico = (state = INIT_STATE, action) => {
	let setServico = '';
	switch (action.payload) {
		case 'normal':
			setServico = 'normal';
			break;
		case 'redespacho':
			setServico = 'redespacho';
			break;
	}
	return { ...state, setServico };
};

export default createReducer(INIT_STATE, {
	[Types.BUSCAR_ESTADOS_CTE_SUCESSO]: buscarEstadosCteSucesso,
	[Types.BUSCAR_NOTAS_CTE_SUCESSO]: buscarNotasCteSucesso,
	[Types.BUSCAR_TRANSPORTADORAS_CTE_SUCESSO]: buscarTransportadorasCteSucesso,
	[Types.BUSCAR_CTE_SUCESSO]: buscarCteSucesso,
	[Types.SET_EMPRESA_SELECIONADA]: setEmpresaSelecionada,
	[Types.SET_TIPO_SERVICO]: setTipoServico,
	[Types.BUSCAR_DISTRIBUIDORAS_CTE_SUCESSO]: buscarDistribuidorasCteSucesso,
	[Types.SET_MOSTRAR]: setMostrar,
	[Types.NOTAS_EDIT_CTE]: notasEditCte,
	[Types.BUSCAR_NOTAS_SUCESSO]: buscarNotasSucesso,
	[Types.EDITAR_CTE_SUCESSO]: editarCteSucesso,
	[Types.INCLUIR_NOT_CTE_SUCESSO]: incluirNotCteSucesso,
	[Types.VALIDAR_CTE_UNICO]: validarCteUnico,
	[Types.LISTA_GERAR_CTE]: listaGerarCte,
	[Types.LISTA_GERAR_CTE_SUCESSO]: listaGerarCteSucesso,
	[Types.DISTRIBUIDORA_CTE]: distribuidoraCte,
	[Types.SET_NOTAS_VIS_CTE]: setNotasVisCte,
	[Types.GERAR_TODOS_CTE]: gerarTodosCte,
	[Types.PESQUISAR_CTE_SUCESSO]: pesquisarCteSucesso,
	[Types.BUSCAR_DIST_TRANSP_SUCESSO]: buscarDistTranspSucesso,
	[Types.SET_LOAD]: setLoad,
	[Types.FORMULARIO_DDS_CTE]: formularioDdsCte
});
